module.exports = __webpack_public_path__ + "static/media/lock-24px.4675ae93.svg";